
/*!
 * Jade - self closing tags
 * Copyright(c) 2010 TJ Holowaychuk <tj@vision-media.ca>
 * MIT Licensed
 */

module.exports = [
    'meta'
  , 'img'
  , 'link'
  , 'input'
  , 'source'
  , 'area'
  , 'base'
  , 'col'
  , 'br'
  , 'hr'
];


/*****************
 ** WEBPACK FOOTER
 ** ./~/mocha/~/jade/lib/self-closing.js
 ** module id = 126
 ** module chunks = 1
 **/